import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";

// Data
import ArticleInfo from "./components/ArticleInfo";
import articleService from "../../../services/articleService";

function handleError(error) {
    if (error.response) {
        console.error("Server error:", error.response);
    } else if (error.request) {
        console.error("Network error:", error.request);
    } else {
        console.error("Error:", error.message);
    }
}

function DetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [article, setArticle] = useState({});
    
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [rejectFeedback, setRejectFeedback] = useState("");

    const fetchArticle = useCallback(async () => {
        try {
            const response = await articleService.getById(id);
            setArticle(response.data);
        } catch (error) {
            handleError(error)
        }
    }, [id]);

    useEffect(() => {
        fetchArticle();
    }, [fetchArticle]);

    const handleStatusChange = async (newStatus, feedback = null) => {
        try {
            const payload = { status: newStatus };
            if (feedback) payload.feedback = feedback;
            await articleService.changeStatus(id, payload);
            fetchArticle();
        } catch (error) {
            handleError(error);
        }
    };

    const handleConfirmReject = () => {
        handleStatusChange("borrador", rejectFeedback);
        setOpenRejectDialog(false);
        setRejectFeedback("");
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox py={3}>
                <Card sx={{ overflow: "visible" }}>
                    <MDBox p={3}>
                        <MDBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h5" fontWeight="medium">
                                Detalles del Artículo
                            </MDTypography>
                            <MDBox display="flex" gap={1}>
                                {article.status === "borrador" && (user?.role === "author" || user?.role === "admin") && (
                                    <MDButton variant="gradient" color="warning" onClick={() => handleStatusChange("revisión")}>
                                        Mandar a revisión
                                    </MDButton>
                                )}
                                {article.status === "revisión" && user?.role === "admin" && (
                                    <>
                                        <MDButton variant="outlined" color="dark" onClick={() => navigate(`/articles/edit/${id}`)}>
                                            Editar Artículo
                                        </MDButton>
                                        <MDButton variant="gradient" color="success" onClick={() => handleStatusChange("publicado")}>
                                            Publicar
                                        </MDButton>
                                        <MDButton variant="gradient" color="error" onClick={() => setOpenRejectDialog(true)}>
                                            Rechazar con Feedback
                                        </MDButton>
                                    </>
                                )}
                            </MDBox>
                        </MDBox>

                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={12}>
                                <ArticleInfo article={article} />
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>

            <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle>Dejar Feedback para el Autor</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Comentarios de Mejora"
                        type="text"
                        fullWidth
                        multiline
                        rows={4}
                        value={rejectFeedback}
                        onChange={(e) => setRejectFeedback(e.target.value)}
                        placeholder="Explícale al autor qué debe mejorar antes de publicar..."
                    />
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenRejectDialog(false)} color="dark" variant="text">
                        Cancelar
                    </MDButton>
                    <MDButton onClick={handleConfirmReject} color="error" variant="gradient">
                        Confirmar Rechazo
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Footer />
        </DashboardLayout>
    );
}

export default DetailsPage;
